import {
  CompletePaymentRequest,
  CompletePaymentSuccessResponse,
  StartPaymentRequest,
  StartPaymentSuccessResponse,
  GetPaymentDetailsRequest,
  GetPaymentDetailsSuccessResponse
} from '@cms-max/medicare-api-sdk'
import { AxiosError } from 'axios'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useMutation, useQuery } from 'react-query'

export const useStartPayment = () => {
  const startPayment = async (payload: StartPaymentRequest) => {
    const res = await medicareApiClient.premiumsApi.startPayment(payload)
    return res.data
  }

  return useMutation<StartPaymentSuccessResponse, AxiosError, StartPaymentRequest>({
    mutationFn: startPayment
  })
}

export const useCompletePayment = () => {
  const completePayment = async (payload: CompletePaymentRequest) => {
    const res = await medicareApiClient.premiumsApi.completePayment(payload)
    return res.data
  }

  return useMutation<CompletePaymentSuccessResponse, AxiosError, CompletePaymentRequest>({
    mutationFn: completePayment
  })
}

export function useFetchPaymentDetails (agencyId: string, appId: string) {
  const detailsReq: GetPaymentDetailsRequest = { agencyTrackingId: agencyId, tcsAppId: appId }

  const fetchPaymentDetails = async (payload: GetPaymentDetailsRequest) => {
    const res = await medicareApiClient.premiumsApi.getPaymentDetails(payload)
    return res.data
  }

  return useQuery<GetPaymentDetailsSuccessResponse | undefined>({
    queryKey: 'paymentDetails',
    queryFn: () => fetchPaymentDetails(detailsReq)
  })
}
